// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2FX4M","resendInfoText":"OnGoingPaymentBox_resendInfoText__33uKo"};